export default __webpack_public_path__ + "static/media/survey-blue.d742f751.svg";